import { minValue, normalDescription } from '@/validation'

export const caption = { descr: normalDescription }
export const fragmentInMillis = { min: minValue(0) }
